import { useEffect, useMemo } from 'react';
import { ThemeProvider } from '@mui/material';
import { COUNTRY } from '@makro-shopping/product-card';
import i18n from './config/i18n/i18n';
import { AppThemeConfig } from './config/theme';
import { BasketContextProvider } from './contexts/Basket.context';
import { DataProvider } from './contexts/DataProvider.context';
import { SessionContextProvider } from './contexts/SessionProvider.context';
import CarouselPage from './mainPage/CarouselPage';
import SendBrowserEvent from './services/sendBrowserEvent.service';
import { Locales, normalizeLocale, toHtmlLanguage } from './types/locale.types';

function App() {
  const searchParams = new URLSearchParams(window.location.search);
  const lang = normalizeLocale(searchParams.get('locale'));
  const deviceTypeProps = searchParams.get('deviceType') || 'desktop';
  const countryCode = searchParams.get('countryCode') || 'TH';

  if (i18n.language !== lang) {
    void i18n.changeLanguage(lang);
  }
  useEffect(() => {
    SendBrowserEvent.isMFEReady();
  }, []);

  // Apply locale-specific class and lang attribute to HTML element
  useEffect(() => {
    document.documentElement.lang = toHtmlLanguage(lang);
    document.documentElement.classList.remove(...Locales.map((locale) => `locale-${locale}`));
    document.documentElement.classList.add(`locale-${lang}`);
  }, [lang]);

  const theme = useMemo(() => AppThemeConfig(deviceTypeProps, countryCode as COUNTRY), [deviceTypeProps, countryCode]);

  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <DataProvider>
          <SessionContextProvider session={null}>
            <BasketContextProvider>
              <CarouselPage />
            </BasketContextProvider>
          </SessionContextProvider>
        </DataProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
